<script>
  import { _ } from 'svelte-intl';
  import CurrentBalance from './CurrentBalance.svelte';
  import Bundles from './Bundles.svelte';
  import SelectedBundle from './SelectedBundle.svelte';
  import Stripe from './Stripe.svelte';
  import { fadeIn, fadeOut } from './transition';
  import { user, packs, alert } from '../../stores';
  import { noop } from 'svelte/internal';
  import BannerBlock from '../banners/BannerBlock.svelte';

  export let title = $_('coin_shop_title');
  export let bundlesTitle = false; // string | false
  export let description = '';
  export let showBalance = true;
  export let focusPrice = undefined; // number?
  export let onSuccess = noop;

  let currentBundle; // Bundle?
  let step;

  $: {
    if (!currentBundle) {
      step = 1;
    } else {
      step = 2;
    }
  }

  const selectBundle = (bundle) => {
    currentBundle = bundle;
  };

  const clearBundle = () => {
    currentBundle = null;
  };

  const purchase = async (bundle) => {
    user.purchasePack(bundle);
    onSuccess();
  };

  const showError = (error) => {
      alert.show({
        type: 'error',
        message: error.message
      });
  };

  const createStripeIntent = (id) => {
    return user.createStripeIntent(id);
  };
</script>

<style lang="stylus">
  .coin-shop
    max-width 464px
    margin auto
    height 100%
    position relative
    margin-top 2rem

  h1
    margin-top 0
    margin-bottom 32px

  :global(.popup) .coin-shop
    max-width 624px
    padding 24px 0
    margin 0
    box-sizing border-box

    @media $bp.desktop
      padding 79px 56px

    h1
      font-size 24px
      line-height 24px
      text-align center

    p
      font-size 18px
      line-height 24px
      text-align center
</style>

<div class="coin-shop">
  {#if step === 1}
    <div class="step" data-cy="shop-1" in:fadeIn out:fadeOut>
      <h1>{title}</h1>
      {#if description}
        <p>{@html description}</p>
      {/if}
      {#if showBalance}
        <CurrentBalance user={$user} />
      {/if}
      <BannerBlock blockName="shop" />
      <Bundles
        title={bundlesTitle}
        bundles={$packs}
        focusPrice={focusPrice}
        onSelectBundle={selectBundle}
      />
    </div>
  {:else if step === 2}
    <div class="step" data-cy="shop-2" in:fadeIn out:fadeOut>
      <SelectedBundle bundle={currentBundle} onBack={clearBundle} />
      <Stripe
        bundle={currentBundle}
        onPurchaseSuccess={purchase}
        onPurchaseError={showError}
        onCreateStripeIntent={createStripeIntent}
      />
    </div>
  {/if}
</div>
